import React from "react";
import styled from "styled-components";
import { Box, Flex } from "reflexbox/styled-components";

import jefLogo from "../assets/images/jef-logo.svg";
import { useApplicationStateValue } from "../application/Application";

const StyledHeader = styled(Flex)`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 17%;
    background-color: rgba(255, 255, 255, 0);
    justify-content: space-around;
    z-index: 10;
`;

const StyledImage = styled(Box)`
    height: 100%;
    width: 30%;
    background: url(${jefLogo}) no-repeat center;
    background-size: contain;
    margin-top: 0.7vh;
`;

const StyledTextContainer = styled(Flex)`
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
`;

const StyledText = styled(Box)`
    line-height: 1;
    color: ${({ theme }) => theme.colors.white};
`;

const Header = () => {
    const {
        appData: { forumLocation, forumPeriod }
    } = useApplicationStateValue();

    const openJahorinaEkonomskiForum = () => {
        //   window.open("web:https://digitalnakonferencija.ba/", "_system");
        window.open("web:https://jahorinaekonomskiforum.com/", "_system");
    };

    return (
        <StyledHeader>
            <StyledImage onClick={openJahorinaEkonomskiForum} />
            <StyledTextContainer>
                <StyledText fontSize={[6]} mb={[1, 1, 2, 2]} fontWeight="bold">
                    {forumPeriod}
                </StyledText>
                <StyledText fontSize={[3, 4]} fontWeight="light">
                    {forumLocation}
                </StyledText>
            </StyledTextContainer>
        </StyledHeader>
    );
};

export default Header;
